import { NameDto } from '../Common/Types'

export interface PromoMaterialDto {
  enabled: boolean
  endDateTime: string | null
  id: string
  imagePath: string | null
  language: NameDto<string>
  name: string | null
  promoMaterialContentType: NameDto
  promoMaterialSize: NameDto
}

interface LandingPageDto {
  id: string
  name: string | null
  promoMaterialBaseUrl: NameDto
  url: string | null
  enabled: boolean
  endDateTime: string | null
  updatedDate: string
  imagePath: string | null
  tickmillCompany: NameDto
  languages: NameDto<string>[]
  order: number
  isDefault: boolean
  promoMaterials: LandingPromoMaterialDto[]
}

interface LandingPromoMaterialDto {
  id: string
  name: string | null
  enabled: boolean
  promoMaterialSize: NameDto
  promoMaterialCategory: NameDto
  promoMaterialType: NameDto
  landingPage: LandingPageDto
  imagePath: string | null
  tickmillCompany: NameDto
  language: NameDto<string>
}

export enum PromoMaterialKey {
  name = 'name',
  language = 'language.name',
  size = 'promoMaterialSize.name',
  category = 'promoMaterialCategory.name',
  type = 'promoMaterialContentType.name',
  active = 'enabled',
  lastUpdated = 'endDateTime',
}
export interface PromoMaterialLandingPageDto {
  id: string
  name: string | null
  enabled: boolean
  promoMaterialSize: NameDto
  promoMaterialCategory: NameDto
  promoMaterialType: NameDto
  landingPage: LandingPageDto
  imagePath: string | null
  tickmillCompany: NameDto
  language: NameDto<string>
  endDateTime: string | null
}

export enum PromoMaterialLandingPageKey {
  name = 'name',
  size = 'promoMaterialSize.name',
  category = 'promoMaterialCategory.name',
  type = 'promoMaterialType.name',
  active = 'enabled',
  lastUpdated = 'endDateTime',
}
